"use strict";

const COOKIE_NAME = 'cookie_consent';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

/**
 * Баннер cookie: кнопка пишет куку и скрывает уведомление. Счётчики не запускает.
 */
const AppCookieConsent = class AppCookieConsent {

	static _bound = false;

	/**
	 * Вешает клик на баннер. Повторный вызов безопасен; если узла ещё нет — ждём следующий.
	 * @returns {void}
	 */
	static init() {
		if (this._bound) return;

		const root = document.querySelector('[data-role="cookie-consent"]');
		if (!root) return;

		if (this.getConsent() !== '') {
			root.remove();

			return;
		}

		this._bound = true;
		root.addEventListener('click', (event) => {
			const button = event.target.closest('[data-cookie-consent]');
			if (!button || !root.contains(button)) return;

			this.setConsent();
			root.remove();
		});
	}

	/**
	 * Текущее значение cookie_consent: любая непустая строка значит, что баннер уже закрывали
	 * @returns {string}
	 */
	static getConsent() {
		const match = document.cookie.match(/(?:^|; )cookie_consent=([^;]*)/);

		return match ? decodeURIComponent(match[1]) : '';
	}

	/**
	 * Пишет cookie_consent=1 на год, Path=/, SameSite=Lax
	 * @returns {void}
	 */
	static setConsent() {
		document.cookie = COOKIE_NAME + '=1'
			+ '; Path=/; Max-Age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
	}
};

const bootCookieConsent = () => AppCookieConsent.init();
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', bootCookieConsent);
} else {
	bootCookieConsent();
}

export {AppCookieConsent};
